import React from 'react';
import 'mapbox-gl/dist/mapbox-gl.css';
import { createRoot } from 'react-dom/client';
import AppRoutes from './routes.jsx';
import './index.css';
import 'mapbox-gl/dist/mapbox-gl.css';
import analyticsService from './services/analyticsService.js';
import { preloadMembers } from './services/membersService.js';

// Initialize Google Analytics
const GA4_MEASUREMENT_ID = import.meta.env.VITE_GA4_MEASUREMENT_ID || 'G-Q9SX5MN4MQ';
analyticsService.initialize(GA4_MEASUREMENT_ID);

// Track initial page view
analyticsService.trackPageView();

// Preload members data for fast agent contact modal access
preloadMembers();


createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AppRoutes />
  </React.StrictMode>,
)
